import { WarningAlt } from '@carbon/react/icons';
import styles from './table-error.module.scss';

// ─────────────────────────────────────
// Props
// ─────────────────────────────────────

interface TableErrorProps {
  error: Error | string;
}

// ─────────────────────────────────────
// Component
// ─────────────────────────────────────

/**
 * Error display component for the DataTable.
 * Shows a warning icon with error message when data loading fails.
 * @param {TableErrorProps} props - Component props
 * @param {Error | string} props.error - Error object or message string
 * @return {JSX.Element} The error display element
 */
export function TableError({ error }: TableErrorProps) {
  const errorMessage = error instanceof Error ? error.message : error;

  return (
    <div className={styles.tableError}>
      <div className={styles.errorContent}>
        <div className={styles.errorIcon}>
          <WarningAlt />
        </div>
        <h3 className={styles.errorTitle}>Something went wrong</h3>
        <p className={styles.errorMessage}>{errorMessage}</p>
      </div>
    </div>
  );
}
